import React, { Component } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { applyDataTable, destroyDataTable } from '../../../custom/dataTable';
import View from '../../../../assets/img/svg/view.svg';
import Edit from '../../../../assets/img/svg/edit.svg';
import Delete from '../../../../assets/img/svg/delete.svg';
import FilterIcon from '../../../../assets/img/svg/FilterIcon.svg'
import del from "../../../../assets/img/svg/Del.svg"
import download from "../../../../assets/img/svg/DownloadIcon.svg"
import Autocomplete from "react-autocomplete"
import { useNavigate } from "react-router-dom";
import Pagination from "../../../custom/Pagination";
import $ from "jquery"
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { TextField, InputBase, Checkbox, InputAdornment, IconButton, Select, MenuItem, FormControl, FormHelperText, Radio, RadioGroup, FormControlLabel } from '@material-ui/core';
import styles from "../../../../assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { downloadsinglewpdocs, getprojectwpdocinfo, deletemulitiwpdocs } from "../../../../actions/WPAction";
import moment from "moment"
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { getSettingsFormat } from "../../../../actions/SettingsAction";

const useStyles = makeStyles((theme) => ({
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
    },
    fontIcon: {
        paddingRight: "8px",
    }
}));

class ListViewWP extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            WP_ListView: [],
            DownDelete: [],
            hide: 0,
            index:1,
            searchData: {
                PermitFrom: "",
                PermitTo: "",
                Permittype: "",
                PageNo: 1,
                PageSize: 10,
                SortBy: 'description',
                SortOrder: 'asc'
            },
        }
    }

    sidebar = () => {
        this.props.navigate("/sidebar");
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
    };
    resize1 = () => {
        $("#WORK1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Workpermits1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Workpermits").removeClass("d-none");
        $("#Workpermits").addClass("d-block");
        $("#WPL").addClass("active-color");
        $("#WPT").addClass("fw-bolder");
    }
    SingleDownload = (i) => {
        this.props.dispatch(downloadsinglewpdocs(i))
    }

    componentDidMount() {
        const { dispatch } = this.props;
        (localStorage.getItem("UserRoles") == "Admin" || localStorage.getItem("UserRoles") == "Supervisor") ? this.setState({ isAccess: true }) : this.setState({ isAccess: false })
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.setState({})
        this.getSettingsFormat(this.state.ProjectId)
        localStorage.removeItem("WPEditId")
        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        $("#WORK1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Workpermits1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Workpermits").addClass("d-none");
        $("#Workpermits").removeClass("d-block");
        $("#WPL").removeClass("active-color");
        $("#WPT").removeClass("fw-bolder");
    }

    getSettingsFormat = (data) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        let apiUrl = API.SETTINGS_PROJECT + data;
        axios({
            method: "get",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.dataTable(this.state.searchData, this.state.ProjectId);
                if (response?.status === 200) {
                    this.props.dispatch({ type: "SETTINGS", data: response.data });
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.dataTable(this.state.searchData, this.state.ProjectId);
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    dataTable = (data, id) => {
        destroyDataTable("staffTable");
        let apiUrl = API.WP_LISTVIEW + "?projectId=" + id + "&PermitFrom=" + data.PermitFrom + "&PermitTo=" + data.PermitTo + "&Permittype=" + data.Permittype +  '&SortBy=' + data.SortBy + '&SortOrder=' + data.SortOrder + '&PageNumber=' + data.PageNo + '&PageSize=' + data.PageSize;
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.dispatch({ type: "WPLIST_DOCS", data: response.data });
                    applyDataTable("staffTable", "", [{ "orderable": false, "targets": [0], visible: this.state.isAccess === false ? false : true }, { type: 'day', targets: [2] }], "", "", "", this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY",[this.state.index,data.SortOrder]);
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    AddNew = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/workpermits/addnew")
    };

    EditPage = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/workpermits/edit")
    };

    ViewPage = () => {
        this.props.navigate("/workpermits/view")
    };
    DeleteItem = () => {
        let tempData = [];
        const { DownDelete } = this.state;
        window.$("#deletepopup").modal("hide");
        this.deletemulitiwpdocs(DownDelete, this.state.ProjectId, this.state.UserRole)
        this.state.DownDelete = [];
        this.setState({});
        $('input[type=checkbox]').prop('checked', false);
    }

    deletemulitiwpdocs = (data, id, modify) => {
        let ids = "";
        if (data && data.length > 0) {
            data.map((val, index) => {
                if (index == 0) {
                    ids += "ids=" + val;
                }
                else {
                    ids += "&ids=" + val;
                }
            })
        }
        let apiUrl = API.WP_LISTVIEW + '/ids?' + ids + "&modify=" + modify;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "DELETE",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.hide = 0;
                    this.setState({})
                    this.state.searchData = {
                        PermitFrom: "",
                        PermitTo: "",
                        Permittype: "",
                        PageNo: 1,
                        PageSize: 10,
                    };
                    this.dataTable(this.state.searchData, this.state.ProjectId);
                    // this.props.dispatch(getprojectwpdocinfo(temp, this.state.ProjectId))
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    renderProjectNames = (state, val) => {
        return state?.Description?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };

    handleProjectNameSearchChange = (e) => {
        this.state.searchData.Description = e.target.value;
        this.setState({});
    };

    handleProjectNameSelectChange = (e) => {
        this.state.searchData.Description = e;
        this.setState({});
    };

    handleDateChange = (e, str) => {
        this.state.searchData[str] = e.target.value;
        this.setState({});
    }

    handleCheckboxChange = (e, x) => {
        const { DownDelete } = this.state;
        if (DownDelete.length == 0) {
            DownDelete.push(x)
        }
        else {
            if (DownDelete.filter((i) => i == x).length == 1) {
                DownDelete.map((i, ind) => (
                    i == x ?
                        DownDelete.splice(ind, 1)
                        : ""
                ))
            } else {
                DownDelete.push(x)
            }
        }
        this.setState({})
        if (DownDelete.length == 1) {
            localStorage.setItem("WPEditId", DownDelete[0])
        }
        this.state.hide = DownDelete.length;
        this.setState({})
    };

    handleRadio = (e) => {
        this.state.searchData.Permittype = e.target.value;
        this.setState({})
    }

    handleDateChange = (e, node) => {
        this.state.searchData[node] = e.target.value;
        this.setState({})
    }

    ResetFilter() {
        const { dispatch } = this.props;
        const input = {
            PermitFrom: "",
            PermitTo: "",
            Permittype: "",
            PageNo: 1,
            PageSize: 10,
            SortBy: 'description',
            SortOrder: 'asc'
        };
        this.state.searchData = input;
        this.setState({});
        // this.dataTable(this.state.searchData, this.state.ProjectId);
        // dispatch(getprojectwpdocinfo(this.state.searchData, this.state.ProjectId))
    };

    filterSearch() {
        const { dispatch } = this.props;
        this.state.index=1;
        this.state.searchData.SortBy='description'
        this.state.searchData.SortOrder='asc'
        this.setState({})
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        this.dataTable(this.state.searchData, this.state.ProjectId);
        // dispatch(getprojectwpdocinfo(this.state.searchData, this.state.ProjectId))
    };

    BackPage = () => {
        this.state.searchData.PageNo = this.state.searchData.PageNo - 1;
        this.setState({})
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        this.dataTable(this.state.searchData, this.state.ProjectId);
        // this.props.dispatch(getprojectwpdocinfo(this.state.searchData, this.state.ProjectId))
    }

    NextPage = () => {
        this.state.searchData.PageNo = this.state.searchData.PageNo + 1;
        this.setState({})
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        this.dataTable(this.state.searchData, this.state.ProjectId);
        // this.props.dispatch(getprojectwpdocinfo(this.state.searchData, this.state.ProjectId))
    }
    handleSort = (data,ind) => {
        if (this.state.searchData.SortBy === data) {
            this.state.searchData.SortOrder = this.state.searchData.SortOrder === "asc" ? "desc" : "asc";
        }
        else {
            this.state.searchData.SortOrder = "asc";
        }
        this.state.searchData.SortBy = data;
        this.state.searchData.PageNumber = 1;
        this.setState({
            index:ind
        });
        this.dataTable(this.state.searchData, this.state.ProjectId);

    }
    render() {
        let { classes, menuToggle } = this.props;

        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-4 w-50 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={() => this.sidebar()} >
                                            <ListItemText id={"WORK" + "1"} className='  textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="WORK" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-8 pt-2 mt-5 w-50 ">
                                    <h4>Work Permits</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className={this.state.isMobile ? "ml-auto scroll-hide border-top" : "ml-auto scroll-hide"} style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isAccess ? <> {this.state.isMobile ? <table className="dataTable " width="100%">
                        <tbody>
                            <tr>
                                <td className="border-right text-center">
                                    <button className={classes.button} onClick={this.EditPage} disabled={this.state.hide == 1 ? false : true}><img src={Edit} style={{ marginTop: '-4px', opacity: this.state.hide == 1 ? '' : '0.5' }}></img>&nbsp;Edit</button>
                                </td>
                                <td className="border-right text-center">
                                    <button className={`${classes.button}`} data-target="#deletepopup" disabled={this.state.hide > 0 ? false : true} data-toggle="modal"><img src={Delete} style={{ marginTop: '-4px', opacity: this.state.hide > 0 ? '' : '0.5' }}></img>&nbsp;Delete</button>
                                </td>
                                <td className="border-right text-center">
                                    <button className={`${classes.button}`} onClick={this.AddNew}><i className="fa fa-plus pr-2" style={{ color: "#00838F", opacity: this.state.isAccess ? '' : '0.5' }}></i>Add New</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                        :
                        <>
                            <div className="row  border-bottom">
                                <div className="col-xl-3  col-md-3 col-lg-3 col-sm-3   d-flex">
                                    <button className={`${classes.button} pl-3`} onClick={this.EditPage} disabled={this.state.hide == 1 ? false : true} style={{ minWidth: '70px' }}><img src={Edit} style={{ marginTop: '-4px', opacity: this.state.hide == 1 ? '' : '0.5' }}></img>&nbsp;Edit</button>
                                    <button className={`${classes.button}`} data-target="#deletepopup" disabled={this.state.hide > 0 ? false : true} data-toggle="modal" style={{ minWidth: '70px' }}><img src={Delete} style={{ marginTop: '-4px', opacity: this.state.hide > 0 ? '' : '0.5' }}></img>&nbsp;Delete</button>
                                    <div className="col-xl-12 p-3 col-md-12 col-lg-12 col-sm-12  ml-2 border-left">
                                        <span className={`${classes.button} cursorPointer`} onClick={this.AddNew} style={{ minWidth: '70px' }}><i className="fa fa-plus pr-2" style={{ color: "#00838F", opacity: this.state.isAccess ? '' : '0.5' }}></i>Add New</span>
                                    </div>
                                </div>
                            </div>
                        </>}
                    </> : <></>}
                    <div className="row" style={{ margin: this.state.isMobile ? "" : "5px" }}>
                        <div className="row px-3">
                            <div className="col-10 pt-2">
                                {this.state.isMobile ? <></> : <h6>Work Permits</h6>}
                            </div>
                            <div className="col-2 pt-2">
                                <button data-toggle="modal" data-target="#custom-modal" className={`${classes.button} float-end`} style={{ minWidth: '70px' }} ><img src={FilterIcon} />&nbsp;Filter </button>
                            </div>
                        </div>
                        <div className={this.state.isMobile ? "col-12 px-4 pt-2 mt-1" : "col-12 px-3 pt-2 mt-1"}>
                            <div className="table-responsive mb-5" style={{ width: "100%" }}>
                                <table id="staffTable" className="table table-hover product_table">
                                    <thead>
                                        <tr className="">
                                            <th className=" border-left" width="3%"><span className="spandoc-thead" style={{ color: "#000000" }}></span></th>
                                            <th className="border-right  border-left" width="39%" style={{ minWidth: window.innerWidth < 1000 ? '300px' : "39%" }} onClick={() => this.handleSort('description',1)}><span className="spandoc-thead" style={{ color: "#000000" }}>Description</span></th>
                                            <th className="border-right" width="9%" style={{ minWidth: window.innerWidth < 1000 ? '80px' : "80px" }} onClick={() => this.handleSort('permitdate',2)}><span className="spandoc-thead" style={{ color: "#000000" }}>Permit Date</span></th>
                                            <th className="border-right" width="11%" style={{ minWidth: window.innerWidth < 1000 ? '100px' : "100px" }} onClick={() => this.handleSort('permittype',3)}><span className="spandoc-thead" style={{ color: "#000000" }}>Permit Type</span></th>
                                            <th className="border-right" width="40%" style={{ minWidth: window.innerWidth < 1000 ? '300px' : "40%" }} onClick={() => this.handleSort('attachments',4)}><span className="spandoc-thead" style={{ color: "#000000" }}>Attachments</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.props.WP_ListView?.WorkPermit && this.props.WP_ListView?.WorkPermit.map((i, index) => (
                                            <tr>
                                                <td className="spandoc-td align-middle border-left"><input type="checkbox" checked={this.state.DownDelete.filter(r=> r === i.Id).length == 1 ? true : false} style={{ width: "16px", height: '16px' }} onChange={(e) => this.handleCheckboxChange(e, i.Id)} /></td>
                                                <td className="spandoc-td align-middle border-right  border-left">{i.Description}</td>
                                                <td className="spandoc-td align-middle border-right">{i.PermitDate && moment(i.PermitDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}</td>
                                                <td className="spandoc-td align-middle border-right">{i.PermitType}</td>
                                                <td className="spandoc-td align-middle border-right "><>
                                                    {i.Atttachments && i.Atttachments.map((a, ind) => (
                                                        <><a href={a.FileUrl} target="_blank">{a.FileName}</a><br></br></>
                                                    ))}
                                                </>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="modal left fade pt-5 mt-3" id="custom-modal" tabIndex={-1} role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" style={{ width: this.state.isMobile ? "250px" : "" }}>
                            <div className="modal-content border-radius">
                                <div className="modal-header">
                                    <div className="row m-0">
                                        <h6 className="modal-title" id="myCenterModalLabel">Advanced Filter</h6>
                                        <div className="col-12">
                                            <img src={FilterIcon} className="cursorPointer" onClick={() => this.ResetFilter()} />&nbsp;
                                            <span className="cursorPointer" onClick={() => this.ResetFilter()}>Reset to default</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-body p-4">
                                    <form id="myform">
                                        <div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Permit Date - From</label>
                                            </div>
                                            <div className="col-7">
                                                <input
                                                    id="type-date1"
                                                    type="date"
                                                    value={this.state.searchData.PermitFrom && moment(this.state.searchData.PermitFrom).format("yyyy-MM-DD")}
                                                    placeholder={this.state.searchData.PermitFrom && moment(this.state.searchData.PermitFrom).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                    onChange={(e) => this.handleDateChange(e, "PermitFrom")}
                                                    style={{ fontSize: 12, height: "38px" }}
                                                    max={JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}
                                                    min={JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}
                                                    className='form-control border-radius'
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Permit Date - To</label>
                                            </div>
                                            <div className="col-7">
                                                <input
                                                    id="type-date1"
                                                    type="date"
                                                    value={this.state.searchData.PermitTo && moment(this.state.searchData.PermitTo).format("yyyy-MM-DD")}
                                                    placeholder={this.state.searchData.PermitTo && moment(this.state.searchData.PermitTo).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                    onChange={(e) => this.handleDateChange(e, "PermitTo")}
                                                    style={{ fontSize: 12, height: "38px" }}
                                                    max={JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}
                                                    min={JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}
                                                    className='form-control border-radius'
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Permit Type</label>
                                            </div>
                                            <div className="col-7">
                                                <RadioGroup row aria-label="gender" value={this.state.searchData.Permittype} onChange={(e) => this.handleRadio(e)} fullWidth>
                                                    <FormControlLabel value="Hot Work Permit" control={<Radio color="default" />} label="Hot Work Permit" size="small" />
                                                    <FormControlLabel value="Cold Work Permit" control={<Radio color="default" />} label="Cold Work Permit" size="small" />
                                                </RadioGroup>
                                            </div>
                                        </div>
                                        {/* <div className="row text-center mt-4">
                                            <div className="col-2"></div>
                                            <div className="col-5" data-dismiss="modal">
                                                <button type="button" className="btn input-group border-radius f-size-13 filter-btn" style={{ backgroundColor: "#00838F", color: "#FFFFFF" }} onClick={() => this.filterSearch()}>Search</button>
                                            </div>
                                            <div className="col-5" data-dismiss="modal">
                                                <button type="button" id="closemodal" className="btn btn-light input-group border-radius f-size-13 filter-btn">Cancel</button>
                                            </div>
                                        </div> */}
                                        <div className="row text-center mt-4">
                                            {this.state.isMobile ? <></> : <div className="col-2"></div>}
                                            <div className={this.state.isMobile ? "col-6" : "col-5"} data-dismiss="modal">
                                                <button type="button" className={`btn btn-primary input-group border-radius f-size-13 ${this.state.isMobile ? " filter-Mobilebtn" : "filter-btn"}`} data-toggle="modal" style={{ backgroundColor: "#00838F", color: "#FFFFFF" }} onClick={() => this.filterSearch()}>Search</button>
                                            </div>
                                            <div className={this.state.isMobile ? "col-6" : "col-5"} data-dismiss="modal">
                                                <button type="button" id="closemodal" className={`btn btn-light input-group border-radius f-size-13 ${this.state.isMobile ? " filter-Mobilebtn" : "filter-btn"}`}>Cancel</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div >
                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                {/* <div class="modal-header">
                            <h1><i class="bi bi-exclamation-triangle-fill text-warning"></i></h1>
                            <div>
                                <h5 class="fw-bold">Warning</h5>
                                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. </p>
                            </div>
                        </div> */}
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                        {/* <i class="bi bi-check-circle-fill text-success"></i> */}
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you
                                            want to delete?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.DeleteItem}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${classes.pagination}`}>
                    <div className={`${classes.paginationItem}`}>
                        {this.state.searchData.PageNo == 1 ? <></> :
                            <ArrowBackIcon className={classes.arrow} onClick={() => this.BackPage()} />}
                        <span className="pl-2 pr-2">Page {this.state.searchData.PageNo}</span>
                        {(this.state.searchData.PageNo == this.props.WP_ListView?.pagination?.PageCount) || (this.props.WP_ListView?.pagination?.PageCount == 0) ? <></> :
                            <ArrowForwardIcon className={classes.arrow} onClick={() => this.NextPage()} />}
                    </div>
                </div>
            </>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        WP_ListView: state.WPReducer.WP_ListView || [],
        settings: state.commonReducer.settings || [],
    };
}

ListViewWP.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ListViewWP))
);

